export default {
  h1_services: "Servicios de inteligencia artificial para médicos",
  Services: "Servicios",
  eduServices: "Cursos",
  AIServices: "Servicios",
  mg: "Mamografía",
  dx: "Radiografía de tórax y fluorografía",
  // rf: "Radiografías",
  "Go to service": "Ir al servicio",
  "Service banner text":
    "Calcule el efecto de implementar inteligencia artificial en su institución",
  Calc: "Calcular",
  "Services title": "Lista de servicios | " + process.env.VUE_APP_INSTALL_NAME,
  "No description service": "Sin descripción",
  "Services cannot loading":
    "Servicio temporalmente no disponible. Inténtelo más tarde",
  "Cash calc title": "Cálculo de ahorro | " + process.env.VUE_APP_INSTALL_NAME,
  "Cash calc": "Cálculo de ahorro",
  "Cash calc desc": "Cuántos recursos puede ahorrar con IA",
  "Cash calc desc about":
    "Ingrese los datos de su institución. Los datos se eliminarán después de salir de la calculadora.",
  "Average cash": "Salario mensual promedio de un radiólogo",
  "Study calc count": "Cantidad de estudios en su institución por mes",
  mmg: "Mamografía",
  ddx: "Radiografía de tórax",
  ct: "TC de tórax",
  "Start calc": "Calcular",
  economy: "Ahorro",
  rub: " rub.",
  "calc time": " h",
  "Calc summary": "Total anual",
  "Without AI": "Sin inteligencia artificial",
  "With AI": "Con inteligencia artificial",
  "Count calc short": "Cant. ",
  "Calc in Year": " por año",
  "Calc item 1": "Descripción <br /> 1 estudio, min",
  "Calc item 2": "Costo de la descripción <br />1 estudio, rub",
  "Calc item 3": "Gastos en <br />descripción",
  "Calc item 4": "Tiempo en <br />descripción, h",
  mmg__count: "MMG",
  ddx__count: "RX/FLG",
  ct__count: "TC",
  "Calc info": "Metodología de cálculo",
};
